import { uhxVariantIds } from 'content/products/uhx/variantIds';
import { isM1UhxBundlingEnabled } from 'content/products/m1/m1UhxBundlingConfig';
import { ProductType } from 'components/shared/Cart/types';
import { CartPolicy } from './types';
import { pass } from './cartLineHelpers';

export const uhxAutoAddPolicy: CartPolicy = (input, _cart, meta) => {
  if (
    !meta.store ||
    !meta.discountOptions.isM1ProductTypePresent ||
    !meta.isCgmCampaignActive ||
    meta.ultrahumanXAdded ||
    !isM1UhxBundlingEnabled(meta.store)
  ) {
    return pass(input);
  }

  const uhxVariantId = uhxVariantIds[meta.store]?.Year1;
  if (!uhxVariantId) return pass(input);

  meta.discountOptions.isUhxProductTypePresent = true;
  const lineItemsToAdd = [
    ...(input.lineItemsToAdd ?? []),
    {
      merchandiseId: uhxVariantId,
      quantity: 1,
      attributes: [{ key: '_product_type', value: ProductType.UHX }],
    },
  ];

  return {
    input: { ...input, lineItemsToAdd },
    reasons: ['auto-add UHX Year1 for active M1 campaign'],
  };
};
